// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a55dc1f","453":"879e1a06","455":"0b182088","977":"bf676f76"}[chunkId] + ".chunk.js";
};